import { useQuery } from '@tanstack/react-query';
import { verifyRolloverByCoinId } from './service';
import { RolloverQueryKeys } from '../../queryKeys';
import { UseVerifyRolloverByCoinIdProps } from './props';
import { VerifyRolloverByCoinIdRequestDto } from '@/services/dto/withdraw/verify-rollover-by-coin-request.dto';
import { WithdrawVerifyResponseDto } from '@/services/dto/withdraw/withdraw-verify-request.dto';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';

export function useVerifyRolloverByCoinId({
  coinId,
  enabled = true,
}: UseVerifyRolloverByCoinIdProps) {
  const params: VerifyRolloverByCoinIdRequestDto = {
    coinId,
  };
  const { data, isPending, isError, error, refetch } = useQuery<
    WithdrawVerifyResponseDto,
    AxiosError<GenericError>
  >({
    queryKey: [RolloverQueryKeys.VerifyByCoinId, params],
    queryFn: verifyRolloverByCoinId,
    enabled: enabled && !!coinId,
  });

  return {
    data,
    isLoading: isPending,
    isError,
    error,
    refetch,
  };
}
